import { render, staticRenderFns } from "./discrepancy-system-transaction-action-column.vue?vue&type=template&id=66bd873e&scoped=true"
import script from "./discrepancy-system-transaction-action-column.vue?vue&type=script&lang=js"
export * from "./discrepancy-system-transaction-action-column.vue?vue&type=script&lang=js"
import style0 from "./discrepancy-system-transaction-action-column.vue?vue&type=style&index=0&id=66bd873e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd873e",
  null
  
)

export default component.exports